import React from 'react';

export default class Page5 extends React.Component {

    render() {

        return <div id="region-main-pad">
            <div id="region-main"><span id="user-notifications"/>
                <div className="region-content">
                    <div role="main"><span id="maincontent"/>
                        <section>
                            <div className="">
                                <div className="ilead-rgt task">
                                    <div className="innerpadding">
                                        <div className="ilead-contentarea">
                                            <div className="circle_title-first"><img
                                                src={require('@images/Browndot.png')}
                                                alt=""/>STOP AND THINK BEFORE YOU TAKE THE RISK...
                                            </div>
                                            <div className="border_subtitle">Steps for knowing when and how to
                                                take risks
                                            </div>
                                            <p>The following grid is designed to help you analyse your ‘risk’ in
                                                context and therefore take a more
                                                informed approach to how and when to take risks.</p>
                                            <div className="innovativeimg">
                                                <img
                                                    src={require('@images/risk-table.png')}
                                                    alt=""/>
                                            </div>

                                            <p>If you feel unable to control the riskier elements of the
                                                situation, you may be relying too heavily
                                                on chance. Consider the following hints and tips to manage your
                                                risk.</p>

                                            <div className="circle_title"><img
                                                src={require('@images/Browndot.png')}
                                                alt=""/>HINTS AND TIPS
                                            </div>
                                            <ul className="greenbullet-list uiheading">
                                                <li><p>Write down the key questions that are worrying you about
                                                    the situation, e.g. what resources
                                                    are needed to complete the work? Take some time to gather
                                                    more information about these
                                                    issues to give you more clarity and reduce ambiguity. This
                                                    will help to increase your
                                                    confidence levels.</p></li>
                                                <li><p>Consider how you could reward yourself in order to
                                                    provide a greater incentive to take
                                                    the risk.</p></li>
                                                <li><p>Think about the benefits and opportunities that taking
                                                    the risk will bring you. Looking at
                                                    the situation from a different angle can help you highlight
                                                    the positive aspects and
                                                    potential openings.</p></li>
                                                <li><p>Take some time away from the activity in order to
                                                    consider whether the risk is really as
                                                    bad as it seems.</p></li>
                                                <li><p>Talk to people who you know take more risks than you. Get
                                                    their take on this situation
                                                    in order to gain a different perspective.</p></li>
                                            </ul>


                                            <div className="left-btn">
                                                <div
                                                    onClick={this.props.handleChangePage('Page4')}
                                                    className="button-next-previous-done task">&lt;&lt; Previous
                                                </div>
                                            </div>
                                            <div className="right-btn">
                                                <div
                                                    onClick={this.props.handleChangePage('Page6')}
                                                    className="button-next-previous-done task">Next &gt;&gt;</div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </section>
                    </div>
                </div>
            </div>
        </div>;
    }
}